import { render, staticRenderFns } from "./OrderHistoricChart.vue?vue&type=template&id=4433e1bc"
import script from "./OrderHistoricChart.vue?vue&type=script&lang=js"
export * from "./OrderHistoricChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports